Event.on('Cart.product.updated', function () {
    location.reload();
});

function check_hidden_inputs(elm) {
    const $registeredInputs = $(elm).closest('form').find('input[name="registered"]');

    if (!$(elm).is(":checked")) {
        $("#" + $(elm).attr("data-box")).addClass("hide");
        $registeredInputs.val(0);
    }
    else {
        $("#" + $(elm).attr("data-box")).removeClass("hide");
        $registeredInputs.val(1);
    }
}

$(function () {
    // old stuff from modules.ctp
    $('input[name="shipping_id"]').bind('change', function () {
        $('input[name="shipping_method"]').val($(this).data('name'));

        var payments = $(this).data('payments');
        $('input[name="payment_id"]').prop('disabled', false);
        $('input[name="payment_id"]').filter(function (index) {
            return _.indexOf(payments, parseInt($(this).val())) == -1;
        }).prop('disabled', true).prop('checked', false).trigger('change');

        if ($(this).val() != $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').val()) {
            $('[name="branch_id"]:checked').prop('checked', false).trigger('change');
        }

        let besteronIsDisabled = true;
        $('.shopping-modules__dependencies .is-besteron').each(function () {
            const $input = $(this).siblings('.form-control');

            if (!$input.is(':disabled')) {
                besteronIsDisabled = false;
            }
        });

        if (besteronIsDisabled) {
            $('.fake-label').addClass('is-disabled').find('.js-accordion-header').trigger('click');
        }
        else {
            $('.fake-label').removeClass('is-disabled');
        }
    });

    $('.shopping-form').on('click', '.js-tigger-login-modal', function (event) {
        event.preventDefault();

        $('#login-modal').modal('show');
    });

    $('input[name="payment_id"]').on('change', function () {
        const $fakeLabel = $('.fake-label');

        $('input[name="payment_method"]').val($(this).data('name'));

        if ($('input[name="payment_id"]:checked').siblings('label').hasClass('is-besteron')) {
            if (!$fakeLabel.hasClass('is-active')) {
                $fakeLabel.addClass('is-active');
            }
        }
        else {
            $fakeLabel.removeClass('is-active');
        }
    });

    $('input[name="shipping_id"]:checked').trigger('change');

    // modules validate
    $('.js-form-cart-modules').on('submit', function (event) {
        event.preventDefault();
    }).validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            let result = true;

            if (!$('[name="payment_id"]').is(':checked')) {
                $('#error-payment').removeClass('is-hidden').fadeIn(500);
                result = false;
            } else {
                if ($('#error-payment').is(':visible')) { $('#error-payment').addClass('is-hidden').fadeOut(500); }
            }

            if (!$('[name="shipping_id"]').is(':checked')) {
                $('#error-shipping').removeClass('is-hidden').fadeIn(500);
                result = false;
            } else {
                if ($('#error-shipping').is(':visible')) { $('#error-shipping').addClass('is-hidden').fadeOut(500); }

                // branch pickup
                if (!$('[name="branch_id"]').is(':checked') && $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    const selectedAccordionHeader = $('[name="branch_id"]').parents('.shopping-modules__item').find('.js-accordion-header');

                    if (!selectedAccordionHeader.hasClass('is-active')) {
                        selectedAccordionHeader.trigger('click')
                    }

                    $('#error-branch').removeClass('is-hidden').fadeIn(500);
                    result = false;
                }
                else {
                    if ($('#error-branch').is(':visible')) { $('#error-branch').addClass('is-hidden').fadeOut(500); }
                }
            }


            if (!result) {
                $('.c-msg--error:visible').slideHere();
            }

            if (result) {
                $('.js-order-submit')
                    .prop('disabled', true)
                    .addClass('is-loading');

                if (window.modulesDatalayerData) {
                    var shippingMethod = $('input[name="shipping_method"]').val();
                    var paymentMethod = $('input[name="payment_method"]').val();

                    window.modulesDatalayerData.ecommerce.checkout.actionField.option = 'delivery:' + shippingMethod + '--payment:' + paymentMethod;
                    window.dataLayer.push(window.modulesDatalayerData)
                }

                form.submit();
            }
        }
    });

    $('.js-form-vouchers').validate();

    // besteron


    // reg form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($("#order-registered, #customer-registered"));

        $("#order-registered, #customer-registered").change(function () {
            check_hidden_inputs($(this));
        });
    }

    if ($('.js-order-rating-form').length > 0) {
        $('.js-order-rating-form').validate({
            submitHandler: function (form) {
                form.submit();
            }
        });
    }

    if ($("#cart-points-amount").length > 0) {
        $("#cart-points-amount").bind("change keyup", function () {
            if (parseInt($(this).val()) > $(this).attr("max")) {
                $(this).val($(this).attr("max"));
            }
            var rate = parseFloat($('.js-form-points').attr('data-discount').replace(",", "."));
            $("#pointsDiscount").html(Format.price(parseInt($(this).val()) * rate));
        }).trigger("change");
    }

    $('.js-form-cart-modules').find('input[type="radio"]').on('change', function () {
        const $form = $(".js-form-cart-modules");

        $.post($form.data('update-action'), $form.serialize(), function (data) {
            const shipping = data.totals.shipping,
                payment = data.totals.payment,
                discount = data.totals.discount,
                isShippingSelected = $('input[name="shipping_id"]:checked').length > 0,
                isPaymentSelected = $('input[name="payment_id"]:checked').length > 0;

            Cart.updates.totals(data.totals);

            if (shipping) {
                $('.js-cart-recap-shipping')
                    .removeClass('is-green')
                    .html(Format.price(shipping));
            } else {
                $('.js-cart-recap-shipping')
                    .removeClass('is-green')
                    .html($('.js-cart-recap-shipping').data(isShippingSelected ? 'free' : 'empty'));

                if (isShippingSelected) {
                    $('.js-cart-recap-shipping').addClass('is-green');
                }
            }

            if (payment) {
                $('.js-cart-recap-payment')
                    .removeClass('is-green')
                    .html(Format.price(payment));
            } else {
                $('.js-cart-recap-payment')
                    .removeClass('is-green')
                    .html($('.js-cart-recap-payment').data(isPaymentSelected ? 'free' : 'empty'));

                if (isPaymentSelected) {
                    $('.js-cart-recap-payment').addClass('is-green');
                }
            }

            // $('.js-cart-recap-shipping').html(shipping ? Format.price(shipping) : $('.js-cart-recap-shipping').data('free'));
            // $('.js-cart-recap-payment').html(payment ? Format.price(payment) : $('.js-cart-recap-payment').data('free'));
        }, "json");
    });
});
